import * as yup from 'yup';

export const pflegepflichtversicherungOptionenSchema = yup.object({
  leistung: yup.string().default(''),
});
